export interface Language {
    language_code_country: string;
    code: string;
    name: string;
}

export const LANGUAGES: Language[] = [
    {
        "language_code_country": "de-DE",
        "code": "DE",
        "name": "German"
    },
    {
        "language_code_country": "fr-FR",
        "code": "FR",
        "name": "French"
    },
    {
        "language_code_country": "hi-IN",
        "code": "HI",
        "name": "Hindi"
    },
    {
        "language_code_country": "zu-ZU",
        "code": "ZU",
        "name": "Zulu"
    },
    {
        "language_code_country": "af-ZA",
        "code": "AF",
        "name": "Afrikaans"
    },
    {
        "language_code_country": "ar-AR",
        "code": "AR",
        "name": "Arabic"
    },
    {
        "language_code_country": "es-ES",
        "code": "ES",
        "name": "Spanish"
    },
    {
        "language_code_country": "ja-JP",
        "code": "JA",
        "name": "Japanese"
    },
    {
        "language_code_country": "zh-CN",
        "code": "ZH",
        "name": "Chinese"
    },
    {
        "language_code_country": "ko-KR",
        "code": "KO",
        "name": "Korean"
    },
    {
        "language_code_country": "pt-BR",
        "code": "PT",
        "name": "Portuguese"
    },
    {
        "language_code_country": "fil-PH",
        "code": "FIL",
        "name": "Filipino"
    },
    {
        "language_code_country": "id-ID",
        "code": "ID",
        "name": "Indonesian"
    },
    {
        "language_code_country": "it-IT",
        "code": "IT",
        "name": "Italian"
    },
    {
        "language_code_country": "th-TH",
        "code": "TH",
        "name": "Thai"
    },
    {
        "language_code_country": "vi-VN",
        "code": "VI",
        "name": "Vietnamese"
    }
];
